/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it support emoji and non-English text?`)
};

const es_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Admite emoji y texto en otros idiomas?`)
};

const de_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt es Emojis und Text in anderen Sprachen?`)
};

const nl_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunt het emoji en niet-Engelse tekst?`)
};

const fr_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prend-il en charge les emoji et le texte non-anglais ?`)
};

const it_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta emoji e testo non inglese?`)
};

const pt_br2_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta emoji e texto em outros idiomas?`)
};

const pt_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta emoji e texto não inglês?`)
};

const ja_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`emojiと非英語テキストをサポートしていますか?`)
};

const zh_b64_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它支持表情符号和非英语文本吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq1_q", locale)
	if (locale === "en") return en_b64_faq1_q(inputs)
	if (locale === "es") return es_b64_faq1_q(inputs)
	if (locale === "de") return de_b64_faq1_q(inputs)
	if (locale === "nl") return nl_b64_faq1_q(inputs)
	if (locale === "fr") return fr_b64_faq1_q(inputs)
	if (locale === "it") return it_b64_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq1_q(inputs)
	if (locale === "pt") return pt_b64_faq1_q(inputs)
	if (locale === "ja") return ja_b64_faq1_q(inputs)
	return zh_b64_faq1_q(inputs)
};